import Vue from 'vue'
import App from './App.vue'
import store from './store'
import 'classlist-polyfill'
import browserDetect from 'vue-browser-detect-plugin'

Vue.use(browserDetect)
Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
